// LUMAVEN — calze PREVENTIVE (solo IT). Marchio di proprietà MEDISISTEM.
// NB: dati forniti dal cliente. "70" e "140" sono NOMI di linea, non valori/unità.
// Nessuna classe di compressione o indicazione sanitaria attribuita autonomamente.
// I valori hex dei colori sono INDICATIVI (i NOMI sono la fonte di verità).
// La linea ANTITROMBO NON è inclusa qui: resta separata e in attesa di aggiornamento.

export const LUMAVEN_HEALTH_NOTE =
  "Le informazioni riportate hanno carattere generale. La scelta dell'esecuzione, del colore e della taglia più adatti può essere valutata anche tramite la misurazione professionale MEDISISTEM.";

const CHIARO = { id: "chiaro", name: "Chiaro", hex: "#E7D9C4" };
const NERO = { id: "nero", name: "Nero", hex: "#141414" };
const ANTRACITE = { id: "antracite", name: "Antracite", hex: "#36393D" };
const BLU = { id: "blu", name: "Blu", hex: "#1F3A5F" };

// Etichette esecuzioni preventive
const EXE = {
  gambaletto: { id: "gambaletto", label: "Gambaletto" },
  autoreggente: { id: "autoreggente", label: "Calza autoreggente" },
  monocollant: { id: "monocollant", label: "Monocollant" },
  "collant-gestante": { id: "collant-gestante", label: "Collant gestante" },
  "collant-calibrato": { id: "collant-calibrato", label: "Collant calibrato" },
};

export const LUMAVEN_LINES = [
  {
    slug: "linea-70",
    id: "lum-linea-70",
    name: "Linea 70",
    displayTitle: "LUMAVEN 70",
    tagline: "Vestibilità leggera e discreta per il benessere quotidiano delle gambe.",
    description:
      "La Linea 70 LUMAVEN è pensata per chi desidera prendersi cura quotidianamente del benessere delle gambe senza rinunciare a una vestibilità femminile e discreta. La gamma comprende differenti esecuzioni, studiate per adattarsi alle diverse occasioni e preferenze personali. La lavorazione leggera e la presenza di elastan favoriscono una vestibilità confortevole e uniforme durante la giornata.",
    executions: ["gambaletto", "autoreggente", "monocollant", "collant-gestante", "collant-calibrato"].map((k) => EXE[k]),
    colors: [CHIARO, NERO],
    composition: [["Poliammide", "83%"], ["Elastan", "17%"]],
  },
  {
    slug: "linea-140",
    id: "lum-linea-140",
    name: "Linea 140",
    displayTitle: "LUMAVEN 140",
    tagline: "Sostegno e comfort con attenzione all'estetica, per l'uso di ogni giorno.",
    description:
      "La Linea 140 LUMAVEN combina sostegno, comfort e attenzione all'estetica in una gamma pensata per il benessere quotidiano delle gambe. Le diverse esecuzioni permettono di scegliere la configurazione più adatta alle proprie preferenze di abbigliamento, mantenendo una vestibilità uniforme e confortevole.",
    executions: ["gambaletto", "autoreggente", "monocollant", "collant-gestante"].map((k) => EXE[k]),
    colors: [CHIARO, NERO],
    composition: [["Poliammide", "83%"], ["Elastan", "17%"]],
  },
];

// Famiglia Calzini Comfort — pagina dedicata con due modelli (Comfort / Comfort Forte).
export const LUMAVEN_COMFORT = {
  slug: "calzini-comfort",
  name: "Calzini Comfort",
  tagline:
    "Calzini dall'aspetto sobrio e discreto, pensati soprattutto per il pubblico maschile ma utilizzabili anche dalla donna.",
  models: [
    {
      id: "comfort",
      name: "Comfort",
      colors: [ANTRACITE, BLU, NERO],
      sizes: [
        "Taglia 1: 35–36",
        "Taglia 2: 36–37",
        "Taglia 3: 38–39",
        "Taglia 4: 39–40",
        "Taglia 5: 40–41",
      ],
      composition: [["Cotone", "63–64%"], ["Poliammide", "28–29%"], ["Elastan", "6–9%"]],
      description:
        "Il calzino LUMAVEN Comfort è pensato per accompagnare il benessere quotidiano delle gambe con uno stile sobrio e versatile. La presenza prevalente di cotone contribuisce a offrire morbidezza, traspirabilità e una sensazione piacevole a contatto con la pelle. Disponibile in colori classici e discreti, è rivolto soprattutto all'uomo, ma può essere utilizzato anche dalla donna.",
    },
    {
      id: "comfort-forte",
      name: "Comfort Forte",
      colors: [BLU, NERO],
      sizes: ["S: 35–38", "M: 39–42", "L: 43–46"],
      composition: [["Cotone", "30%"], ["Poliammide", "46%"], ["Elastan", "24%"]],
      description:
        "LUMAVEN Comfort Forte è la versione più strutturata della famiglia Comfort. La maggiore presenza di elastan assicura una vestibilità più sostenuta, mantenendo la morbidezza del cotone e un aspetto adatto all'utilizzo quotidiano. I colori essenziali e l'impostazione discreta lo rendono particolarmente indicato per il pubblico maschile.",
    },
  ],
};

export const getLumavenLine = (slug) => LUMAVEN_LINES.find((l) => l.slug === slug);

// --- CALZE ANTITROMBO LUMAVEN (linea separata dalle preventive) --------------
// NB: nessun riferimento al concorrente (ELIVAR A.T.E., KOS Biomedica); il
// sistema autoreggente si chiama "Soft Touch". Nessuna affermazione assoluta.
// Colore commerciale, composizione tessile e foto ufficiali: ancora da fornire.
export const LUMAVEN_ANTITROMBO = {
  slug: "calza-antitrombo",
  name: "Calza antitrombo LUMAVEN",
  subtitle: "Sistema autoreggente con zona di grip integrata",
  intro: [
    "La calza antitrombo LUMAVEN è progettata per offrire compressione graduata, comfort e stabilità nelle situazioni in cui è richiesta una profilassi antitromboembolica secondo indicazione sanitaria. La gamma comprende tre differenti esecuzioni, dal gambaletto al modello alla coscia, per rispondere a diverse esigenze di utilizzo e vestibilità.",
    "Nella versione autoreggente, il sistema Soft Touch utilizza una zona di grip integrata direttamente nel tessuto, senza la tradizionale balza elastica applicata. Questa soluzione contribuisce a rendere il bordo superiore più morbido e traspirante, favorendo una tenuta uniforme e limitando l'effetto costrittivo.",
  ],
  note: "La scelta dell'esecuzione e della taglia deve essere effettuata sulla base delle indicazioni del personale sanitario e di una corretta rilevazione delle misure.",
  features: [
    "Compressione dichiarata: 18–21 mmHg",
    "Compressione graduata",
    "Sistema autoreggente Soft Touch",
    "Zona di grip integrata nel tessuto",
    "Silicone medicale biocompatibile e non citotossico",
    "Assenza della tradizionale balza elastica applicata",
    "Bordo superiore morbido e traspirante",
    "Assenza di cuciture di raccordo nella zona superiore",
    "Struttura studiata per favorire stabilità e vestibilità",
    "Sistema progettato per limitare lo scivolamento e l'arrotolamento del bordo",
    "Tecnologia brevettata del produttore",
  ],
  executions: [
    {
      id: "ad-gambaletto",
      code: "AD",
      label: "Gambaletto",
      img: "/products/lumaven-antitrombo/gambaletto.jpg",
      desc: "Esecuzione al polpaccio con tenuta autoreggente. Per la scelta della taglia sono fondamentali la circonferenza della caviglia (cB), del polpaccio (cC) e l'altezza del gambaletto (lD).",
      measures: ["cB", "cC", "lD"],
      lengths: ["Corta: lD inferiore a 37 cm", "Normale: lD da 37 a 42 cm"],
    },
    {
      id: "ag-coscia",
      code: "AG",
      label: "Calza alla coscia autoreggente Soft Touch",
      img: "/products/lumaven-antitrombo/coscia.jpg",
      desc: "Esecuzione alla coscia con sistema autoreggente Soft Touch e zona di grip integrata nel tessuto. Per la scelta della taglia sono fondamentali la circonferenza della caviglia (cB), del polpaccio (cC), della coscia (cG) e l'altezza (lG).",
      measures: ["cB", "cC", "cG", "lG"],
      lengths: ["Corta: lG inferiore a 71 cm", "Normale: lG da 71 a 84 cm", "Lunga: lG superiore a 84 cm"],
    },
    {
      id: "ag-monocollant",
      code: "AG",
      label: "Monocollant ambidestro",
      img: "/products/lumaven-antitrombo/monocollant.jpg",
      desc: "Monocollant utilizzabile su entrambi i lati (ambidestro). Per la scelta della taglia sono fondamentali la circonferenza della caviglia (cB), del polpaccio (cC), della coscia (cG) e l'altezza (lG).",
      measures: ["cB", "cC", "cG", "lG"],
      lengths: ["Corta: lG inferiore a 71 cm", "Normale: lG da 71 a 84 cm", "Lunga: lG superiore a 84 cm"],
    },
  ],
  softTouch: {
    title: "Tenuta integrata, senza balza elastica applicata",
    text: [
      "Nel sistema Soft Touch, il silicone medicale viene immagliato direttamente nel tessuto della zona di grip. Il bordo superiore è completato da una parte ripiegata morbida e traspirante, senza la tradizionale balza elastica siliconata applicata e senza cuciture di raccordo.",
      "Questa struttura è progettata per migliorare il comfort e la stabilità della calza, limitare l'arrotolamento del bordo e distribuire la tenuta in maniera più uniforme. L'assenza della balza applicata contribuisce inoltre a ridurre il possibile effetto costrittivo nella zona femorale.",
    ],
    patentNote: "Tecnologia brevettata del produttore.",
  },
  measureGuide: [
    ["cB", "Circonferenza della caviglia"],
    ["cC", "Circonferenza del polpaccio"],
    ["cG", "Circonferenza della coscia"],
    ["lD", "Altezza per il gambaletto"],
    ["lG", "Altezza per la calza alla coscia o il monocollant"],
  ],
  sizeTable: {
    cols: ["XS", "S", "M", "L", "XL", "XXL"],
    rows: [
      ["cG (coscia)", "46–56 cm", "52–61 cm", "56–65 cm", "60–69 cm", "64–73 cm", "68–77 cm"],
      ["cC (polpaccio)", "27–34 cm", "30–37 cm", "33–40 cm", "36–43 cm", "40–47 cm", "44–51 cm"],
      ["cB (caviglia)", "17–21 cm", "19–23 cm", "21–25 cm", "23–27 cm", "25–29 cm", "27–31 cm"],
    ],
  },
  // Colori identificativi della TAGLIA (sulla punta): NON sono i colori della calza.
  sizeColors: [
    ["XS", "Azzurro", "#7FB3E0"],
    ["S", "Rosso", "#D0342C"],
    ["M", "Verde", "#2E8B6B"],
    ["L", "Giallo", "#E7C44B"],
    ["XL", "Nero", "#141414"],
    ["XXL", "Marrone", "#6B4A2B"],
  ],
};

// Card per la pagina principale LUMAVEN (preventive)
export const LUMAVEN_PREVENTIVE_CARDS = [
  { id: "lum-linea-70", name: "Linea 70", to: "/prodotti/lumaven/linea-70", cover: "/products/lumaven-preventive/gambaletto.jpg", desc: "Vestibilità leggera e discreta. Gambaletto, autoreggente, monocollant, collant gestante e collant calibrato." },
  { id: "lum-linea-140", name: "Linea 140", to: "/prodotti/lumaven/linea-140", cover: "/products/lumaven-preventive/collant.jpg", desc: "Sostegno e comfort con attenzione all'estetica. Gambaletto, autoreggente, monocollant e collant gestante." },
  { id: "lum-calzini-comfort", name: "Calzini Comfort", to: "/prodotti/lumaven/calzini-comfort", cover: "/products/lumaven-comfort/comfort.webp", desc: "Calzini sobri e discreti, nelle versioni Comfort e Comfort Forte." },
];
